import angular from 'angular';
import CategoriesFilterModule from './categories-filter/categories-filter';
import FeaturedProductsModule from './featured-products/featured-products';
import NewProductsModule from './new-products/new-products';
import MostSelledProductsModule from './most-selled-products/most-selled-products';
import RelatedProductsModule from './related-products/related-products';
import CatalogService from './catalog.service';
import ModalQuantityCartController from './modal-quantity-cart/modal-quantity-cart.controller';
import ModalConfirmationController from './modal-confirmation/modal-confirmation.controller';
import ModalCommentsController from './modal-comments/modal-comments.controller';

import CategoryModule from './category/category';
import ProductsListModule from './products-list/products-list';
import ProductDetailModule from './product-detail/product-detail';
import comparModule from './compare-products/compare-products';
import ProductNotFound from './product-not-found/product-not-found';
import fastSearch from './fast-search/fast-search';
import salesModule from './sales/sales';
import ProcedureListModule from './procedure-list/procedure-list';
import ProcedureDetailModule from './procedure-detail/procedure-detail';
import EventDetailModule from './events/event-detail/event-detail';
import eventsModule from './events/events';

import boxProductsModule from './box-products/box-products';
import boxProductsMiniModule from './box-products-mini/box-products-mini';
import modalConfirmationSaveItemsModal from './modal-confirmation-save-items/modal-confirmation-save-items';

import ProductsListFiltersModule from './products-list-filters/products-list-filters';

let CatalogModule = angular.module('catalog', [
  CategoriesFilterModule.name,
  fastSearch.name,
  salesModule.name,
  ProductDetailModule.name,
  ProductNotFound.name,
  comparModule.name,
  NewProductsModule.name,
  ProductsListModule.name,
  RelatedProductsModule.name,
  CategoryModule.name,
  MostSelledProductsModule.name,
  FeaturedProductsModule.name,
  boxProductsModule.name,
  boxProductsMiniModule.name,
  ProcedureListModule.name,
  ProcedureDetailModule.name,
  EventDetailModule.name,
  modalConfirmationSaveItemsModal.name,
  ProductsListFiltersModule.name,
  eventsModule.name

])
  .controller('ModalQuantityCartController', ModalQuantityCartController)
  .controller('ModalConfirmationController', ModalConfirmationController)
  .controller('ModalCommentsController', ModalCommentsController)
  .service('CatalogService', CatalogService);

export default CatalogModule;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/catalog/catalog.js
 **/